import { useI18n } from '@catawiki/cata-style';
import { Currency } from '@catawiki/runtime-toolkit';

import { toCurrency, toPercentage } from '@/shared/helpers/format';

import { SELLER_FEES_TIERS } from '../../constants';

export const SellerFixedFeeTiers = () => {
  const i18n = useI18n();

  const currency = Currency.CurrencyCodes.EURO;

  return (
    <>
      {SELLER_FEES_TIERS.map((tier, index) => {
        const fromRange = toCurrency(i18n, tier.from, currency, {
          precision: 0,
        });

        const toRange = tier.to
          ? ` - ${toCurrency(i18n, tier.to, currency, {
              precision: 0,
            })}`
          : ' +';

        const feePercentage = toPercentage(i18n, tier.percent, {
          strip_insignificant_zeros: true,
        });

        const fixedFee = tier.fee
          ? ` + ${toCurrency(i18n, tier.fee, currency, {
              stripInsignificantZeros: Number.isInteger(tier.fee),
              precision: Number.isInteger(tier.fee) ? 0 : 2,
            })}`
          : '';

        return (
          <div
            className="tw:flex tw:justify-between u-g-xxl-6 u-m-b-xxs"
            key={index}
          >
            <span>
              {fromRange}
              {toRange}
            </span>
            <span>
              {feePercentage}
              {fixedFee}
            </span>
          </div>
        );
      })}
    </>
  );
};
